import { T, useGT } from 'gt-react';
import MDBox from 'src/components/md/MDBox';
import MDTypography from 'src/components/md/MDTypography';
import Modal from 'src/components/modal/Modal';
import ApiError from 'src/api/ApiError';

interface Props {
  open: boolean;
  onClose: () => void;
  onConfirm: () => void;
  isLoading?: boolean;
  error?: ApiError;
}

const RejectSalesOrderDraftModal: React.FC<Props> = ({
  open,
  onClose,
  onConfirm,
  isLoading,
  error,
}) => {
  const gt = useGT();

  return (
    <Modal
      open={open}
      title={gt('Are you sure?', {
        context: 'modal title confirming ignore purchase order',
      })}
      closeable={false}
      isLoading={isLoading}
      error={error}
      onCloseButton={{
        text: gt('Cancel', { context: 'modal dismiss button' }),
        onClick: onClose,
        disabled: isLoading,
      }}
      additionalButtons={[
        {
          text: gt('Ignore Purchase Order', {
            context:
              'button to ignore and remove purchase order from active list',
          }),
          variant: 'contained',
          color: 'error',
          onClick: onConfirm,
          disabled: isLoading,
        },
      ]}
    >
      <MDBox>
        <MDTypography variant="body2" color="text.secondary">
          <T context="explains what happens when ignoring a purchase order draft">
            This purchase order will be ignored and removed from the active
            orders list. You can still view it by adjusting your filters to
            include ignored and rejected orders.
          </T>
        </MDTypography>
      </MDBox>
    </Modal>
  );
};

export default RejectSalesOrderDraftModal;
